/*
 * Kunbi birthday popup runtime.
 * - Fires on 25% scroll depth OR 800ms scroll-idle after user has engaged
 * - Single-step form: email + day + month + YEAR captured together, one submit
 * - Non-modal, bottom-right slide-in card; hero stays visible
 * - Kills Klaviyo/Privy signup forms that inject on load (they steal our slot)
 * - Cookie'd 30 days on dismiss, 365 days on complete
 * - Klaviyo API wire deferred: stores email+DOB in localStorage placeholder,
 *   POSTs to window.KUNBI_KLAVIYO_ENDPOINT if present
 * - Also opens on click of any [data-kunbi-bday-open] element (offer bar, footer link)
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'kunbi_bday_seen';
  var COOKIE_DAYS = 30;
  var SCROLL_DEPTH_PCT = 0.25;
  var SCROLL_IDLE_MS = 800;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function suppressForeignPopups() {
    var selectors = [
      '.klaviyo-form-version-cid_1',
      '[class*="klaviyo-form-"]',
      'div[data-testid="klaviyo-form"]',
      '.kl-private-reset-css-Xuajs1',
      'div[id^="lightbox-form-"]',
      'div[data-privy-name]',
      '.privy-container',
      '.needsclick[id^="lightbox"]'
    ];
    function purge() {
      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
          if (el.parentNode) { el.parentNode.removeChild(el); }
        });
      });
    }
    purge();
    var observer = new MutationObserver(purge);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  function boot() {
    suppressForeignPopups();

    var card = document.getElementById('kunbi-bday');
    if (!card) return;

    document.querySelectorAll('[data-kunbi-bday-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    if (!getCookie(COOKIE_NAME)) {
      var triggered = false;
      var idleTimer;
      function trigger() {
        if (triggered) return;
        triggered = true;
        cleanup();
        open();
      }
      function onScroll() {
        var scrolled = window.scrollY + window.innerHeight;
        var total = document.documentElement.scrollHeight;
        if (total > 0 && scrolled / total >= SCROLL_DEPTH_PCT) {
          trigger();
          return;
        }
        clearTimeout(idleTimer);
        idleTimer = setTimeout(trigger, SCROLL_IDLE_MS);
      }
      function cleanup() {
        window.removeEventListener('scroll', onScroll);
        clearTimeout(idleTimer);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    card.querySelectorAll('[data-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.getAttribute('data-open') === 'true') {
        close();
      }
    });

    var form = card.querySelector('[data-step-form="1"]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailField = form.email;
      var dayField = form.day;
      var monthField = form.month;
      var yearField = form.year;
      var tipsField = form.daily_tips;
      var emailErr = card.querySelector('[data-error-for="email"]');
      var dobErr = card.querySelector('[data-error-for="dob"]');

      var email = emailField.value.trim();
      var day = parseInt(dayField.value, 10);
      var month = parseInt(monthField.value, 10);
      var year = parseInt(yearField.value, 10);
      var dailyTipsOptin = tipsField ? !!tipsField.checked : false;
      var thisYear = new Date().getFullYear();

      var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      var dayValid = day && day >= 1 && day <= 31;
      var monthValid = month && month >= 1 && month <= 12;
      var yearValid = year && year >= (thisYear - 90) && year <= (thisYear - 13);
      var dobValid = dayValid && monthValid && yearValid;

      // Extra check: the date has to actually exist (kills Feb 30 etc)
      if (dobValid) {
        var d = new Date(year, month - 1, day);
        if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) {
          dobValid = false;
        }
      }

      if (!emailValid) {
        emailErr.textContent = 'Enter a valid email so we know where to send the gift.';
        emailErr.hidden = false;
        emailField.focus();
        return;
      } else {
        emailErr.hidden = true;
      }

      if (!dobValid) {
        dobErr.textContent = 'Pick a valid day, month and year for your birthday.';
        dobErr.hidden = false;
        if (!dayValid) { dayField.focus(); }
        else if (!monthValid) { monthField.focus(); }
        else { yearField.focus(); }
        return;
      } else {
        dobErr.hidden = true;
      }

      var submitBtn = form.querySelector('.kunbi-bday__cta');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Saving...';

      submitToBackend(email, day, month, year, dailyTipsOptin)
        .then(function () {
          setCookie(COOKIE_NAME, 'complete', 365);
          showConfirmation(day, month);
        })
        .catch(function (err) {
          console.warn('[kunbi-bday] submit failed:', err);
          setCookie(COOKIE_NAME, 'complete', 365);
          showConfirmation(day, month);
        });
    });

    function goToStep(n) {
      card.querySelectorAll('.kunbi-bday__step').forEach(function (s) {
        s.removeAttribute('data-active');
      });
      var target = card.querySelector('.kunbi-bday__step[data-step="' + n + '"]');
      if (target) {
        target.setAttribute('data-active', 'true');
        var focusable = target.querySelector('input, select, button');
        if (focusable) setTimeout(function () { focusable.focus(); }, 100);
      }
    }

    function showConfirmation(day, month) {
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      var heading = card.querySelector('[data-confirm-heading]');
      var body = card.querySelector('[data-confirm-body]');
      var monthName = months[month - 1];
      var daysUntil = computeDaysUntil(day, month);
      heading.textContent = 'Every ' + day + ' ' + monthName + ', a gift.';
      body.textContent = daysUntil === 0
        ? 'Happy birthday, your gift is on the way.'
        : 'Your first one lands in ' + daysUntil + ' day' + (daysUntil === 1 ? '' : 's') + '.';
      goToStep(2);
    }

    function computeDaysUntil(day, month) {
      var now = new Date();
      var nextBday = new Date(now.getFullYear(), month - 1, day);
      if (nextBday < now) nextBday.setFullYear(now.getFullYear() + 1);
      return Math.round((nextBday - now) / 864e5);
    }

    function submitToBackend(email, day, month, year, dailyTipsOptin) {
      var KLAVIYO_COMPANY_ID = 'XGqSi4';
      var METRIC_NAME = 'Signed Up for Birthday Club';

      // Local backup queue in case Klaviyo call fails
      try {
        var existing = JSON.parse(localStorage.getItem('kunbi_bday_queue') || '[]');
        existing.push({ email: email, day: day, month: month, year: year, daily_tips: !!dailyTipsOptin, ts: Date.now() });
        localStorage.setItem('kunbi_bday_queue', JSON.stringify(existing));
      } catch (e) {}

      // Set the identify cookie so browse events attach to this profile
      try {
        var d = new Date();
        d.setTime(d.getTime() + 365 * 864e5);
        document.cookie = 'kunbi_klv_email=' + encodeURIComponent(email) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
      } catch (e) {}

      var profileProps = {
        birthday_day: day,
        birthday_month: month,
        birthday_year: year,
        daily_tips_optin: !!dailyTipsOptin,
        source: 'Kunbi Bday Popup'
      };

      var payload = {
        data: {
          type: 'event',
          attributes: {
            properties: profileProps,
            metric: {
              data: { type: 'metric', attributes: { name: METRIC_NAME } }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: profileProps
                }
              }
            }
          }
        }
      };

      return fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.ok || r.status === 202) return true;
        return Promise.reject(r);
      });
    }

    function open() {
      card.hidden = false;
      void card.offsetHeight;
      card.setAttribute('data-open', 'true');
      goToStep(1);
    }

    function close() {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      card.removeAttribute('data-open');
      setTimeout(function () { card.hidden = true; }, 320);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
